import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IPerformExtractEncryptionActionOnDatasourcesParams extends IMultipleIdsParams {
  type: string;
}

export class PerformExtractEncryptionActionOnDatasourcesRequest extends Request<IPerformExtractEncryptionActionOnDatasourcesParams, IResult> {
  constructor(ids: string[], type: string) {
    super('performExtractEncryptionActionOnDatasources', {
      ids: ids,
      type: type
    });
  }
}
